import { memberAssistantSchema } from 'store/schemas/database.schemas';
import { putDatabase, deleteFromDatabase } from 'store/actions/database.actions';
import MemberAssistantsRepository from 'services/repositories/MemberAssistantsRepository';
import { actionCreators } from 'store/actions/metaDatabase.memberAssistants.actions';
import { actionCreators as reservationActionCreators } from 'store/actions/metaDatabase.reservations.actions';
import { normalize } from 'normalizr';
import { buildMetaMemberAssistantSelector } from 'store/selectors/memberAssistants.selector';
import TravelAgentAssistantsRepository from 'services/repositories/TravelAgentAssistantsRepository';
import { loadAll } from './helpers';

export const memberAssistantsIncludes = [
    'assistant.memberEmails',
    'assistant.memberPhones',
];

export function loadMemberAssistants(memberId = null)
{
    return async (dispatch) =>
    {
        const summaryIncludes = memberAssistantsIncludes;
        const query = { memberId };
        const response = await dispatch(
            loadAll(query, summaryIncludes, buildMetaMemberAssistantSelector, actionCreators, new MemberAssistantsRepository(), memberAssistantSchema, query),
        );

        if (!response)
        {
            return;
        }

        const memberAssistants = response.response.data;

        Object.values(memberAssistants).forEach((memberAssistant) =>
        {
            dispatch(actionCreators._setLoadedIncludes(memberAssistant.id, memberAssistantsIncludes));
        });
    };
}

export function deleteMemberAssistants(memberAssistantId)
{
    return async (dispatch) =>
    {
        const repository = new MemberAssistantsRepository();
        const response = await repository.destroy(memberAssistantId);
        const memberAssistant = response.response;

        if (response.response_code !== 200)
        {
            if (response.messages && response.messages.length > 0)
            {
                throw new Error(response.messages[0]);
            }
            throw new Error('Error sending information, try again!');
        }

        dispatch(deleteFromDatabase(memberAssistantId, memberAssistantSchema.key));

        return memberAssistant;
    };
}

export function saveMemberAssistants(data)
{
    return async (dispatch) =>
    {
        const repository = new MemberAssistantsRepository();
        const response = await repository.add(data, memberAssistantsIncludes);
        const memberAssistant = response.response;

        const result = normalize(memberAssistant, memberAssistantSchema);
        dispatch(putDatabase(result.entities));
        dispatch(actionCreators._setLoadedIncludes(memberAssistant.id, memberAssistantsIncludes));

        if (data.reservation_id)
        {
            dispatch(reservationActionCreators._needUpdate(data.reservation_id, true));
        }

        return memberAssistant;
    };
}

export function saveMemberAssistant(data)
{
    return async (dispatch) =>
    {
        const repository = new TravelAgentAssistantsRepository();
        const response = await repository.add(data);

        if (!response.isSuccess())
        {
            throw Error(response.mergeMessages());
        }

        const memberAssistant = response.response;

        const result = normalize(memberAssistant, memberAssistantSchema);
        dispatch(putDatabase(result.entities));
        dispatch(actionCreators._setLoadedIncludes(memberAssistant.id, memberAssistantsIncludes));

        return memberAssistant;
    };
}
